<script type="text/babel">
import { ReplaySubject } from 'rxjs'
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'

export default {
    mixins: [HasLoadingState, ManagesModalState],

    props: ['dataAmbassadorship'],

    data() {
        return {
            ambassadorship: this.dataAmbassadorship,
            contents: {},
            status: '',
            refreshChat: new ReplaySubject(1),
            initializedChat: true,
        }
    },

    computed: {
        statusIndication() {
            return this.ambassadorship.status === 'active' ? 'success' : 'danger'
        },
    },

    created() {
        this.load()
    },

    methods: {
        load() {
            axios
                .get(route('api.ambassadorship.contents', this.ambassadorship))
                .then(response => {
                    this.contents = response.data.data
                })
                .then(this.finishLoading())
        },

        setUpdatedAmbassadorship(ambassadorship) {
            Object.assign(this.ambassadorship, ambassadorship.data)
        },
    },
}
</script>
